import { RefreshIcon } from '@sbab-ui/icons'

interface Props {
  resetHandler: () => void
}

function ResetButton({ resetHandler }: Readonly<Props>) {
  return (
    <button onClick={resetHandler} className="flex">
      <RefreshIcon /> <span>Återställ kalkylen</span>
    </button>
  )
}

export default ResetButton
